/**
 * Case-insensitive, all-words-must-match search: every whitespace-separated word
 * in `search` must appear somewhere in `haystack`. An empty search matches all.
 */
export function matchesSearch(haystack: string, search: string): boolean {
  const words = search.trim().toLowerCase().split(/\s+/).filter(Boolean);
  if (words.length === 0) return true;
  const value = haystack.toLowerCase();
  return words.every(word => value.includes(word));
}
